module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-dusty-rose-4-307c1625fab050191a6cf5e5926f0ea7.webp";